import { MutationTree } from 'vuex'
import { AdminDetail, AdminState, Periods } from './types'

export enum AdminMutations {
  SET_ADMINDETAIL = 'SET_ADMINDETAIL',
  SET_LOADER = 'SET_LOADER',
  SET_PERIODS = 'SET_PERIODS'
}

export const mutations: MutationTree<AdminState> = {
  [AdminMutations.SET_ADMINDETAIL](state: AdminState, payload: AdminDetail) {
    state.adminDetail = payload
  },
  [AdminMutations.SET_LOADER](state: AdminState, payload: boolean) {
    state.loadingAdmin = payload
  },
  [AdminMutations.SET_PERIODS](state: AdminState, payload: Array<Periods>) {
    state.periods = payload
  }
}
